//@flow
import { gql, graphql } from "react-apollo"
import type { SlideFormViewProps } from "../types"

const QUERY_SLIDE_DETAILS = gql`
  query FindSlide($attractLoopId: ID!, $id: ID!) {
    slide(attractLoopId: $attractLoopId, id: $id) {
      id
      title
      mediaURL
      assetId
      localizedHeadlineText {
        en
        es
      }
      localizedSecondaryText {
        en
        es
      }
      position
    }
  }
`
const skip = (props: SlideFormViewProps): boolean => {
  return typeof props.match.params.id === "undefined"
}

const options = (props: SlideFormViewProps) => ({
  variables: {
    attractLoopId: props.attractLoopId,
    id: props.match.params.id
  }
})

const withSlideFormDetails = graphql(QUERY_SLIDE_DETAILS, {
  options,
  skip,
  name: "details"
})

export default withSlideFormDetails



// WEBPACK FOOTER //
// ./src/Slides/queries/withSlideFormDetails.js